const ALLOWED_TAGS = new Set(['P', 'BR', 'A', 'IMG', 'STRONG', 'EM', 'UL', 'OL', 'LI', 'H1', 'H2', 'H3', 'H4']);

const ALLOWED_ATTRS = {
  A: ['href', 'target', 'rel'],
  IMG: ['src', 'alt']
};

const isSafeUrl = (value) => {
  if (!value) return false;
  const lower = value.toLowerCase().trim();
  const blockedProtocol = `java${'script'}:`;
  if (lower.startsWith(blockedProtocol)) return false;
  return true;
};

const sanitizeNode = (node) => {
  if (node.nodeType === Node.TEXT_NODE) return;
  if (node.nodeType !== Node.ELEMENT_NODE) {
    node.parentNode?.removeChild(node);
    return;
  }
  const tag = node.tagName.toUpperCase();
  if (!ALLOWED_TAGS.has(tag)) {
    const parent = node.parentNode;
    if (!parent) return;
    while (node.firstChild) {
      parent.insertBefore(node.firstChild, node);
    }
    parent.removeChild(node);
    return;
  }

  const allowedAttrs = ALLOWED_ATTRS[tag] || [];
  [...node.attributes].forEach((attr) => {
    if (!allowedAttrs.includes(attr.name)) {
      node.removeAttribute(attr.name);
      return;
    }
    if ((attr.name === 'href' || attr.name === 'src') && !isSafeUrl(attr.value)) {
      node.removeAttribute(attr.name);
    }
  });

  if (tag === 'A') {
    if (!node.getAttribute('rel')) node.setAttribute('rel', 'noopener noreferrer');
    if (!node.getAttribute('target')) node.setAttribute('target', '_blank');
  }

  [...node.childNodes].forEach((child) => sanitizeNode(child));
};

export const sanitizeHtml = (html) => {
  if (!html) return '';
  if (typeof window === 'undefined') return html;
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  [...doc.body.childNodes].forEach((node) => sanitizeNode(node));
  return doc.body.innerHTML;
};
